type GAEvent =
  | 'page_view'
  | 'login'
  | 'payment_initiated'
  | 'payment_initiate_error'
  | 'trip_paid'

interface GAEventData {
  [key: string]: unknown
}

interface PageViewEventData extends GAEventData {
  page_location: string
  page_title: string
}

interface LoginEventData extends GAEventData {
  email?: string
  phone_number?: string
}

interface PaymentInitiated extends GAEventData {
  transactionId: string
  amount: number
  currencyName?: string
  tripId: string
}
interface PaymentInitiateError extends GAEventData {
  message: string
  tripId?: string
}

interface TripPaid extends GAEventData {
  tripId: string
  transactionId: string
  amount: number
  currencyName?: string
}

type EventMap = {
  page_view: PageViewEventData
  login: LoginEventData
  payment_initiated: PaymentInitiated
  payment_initiate_error: PaymentInitiateError
  trip_paid: TripPaid
}

export interface IGoogleAnalyticsService {
  pageView: (payload: PageViewEventData) => void
  trackEvent: <T extends GAEvent>(eventName: T, data: EventMap[T]) => void
}

export class GoogleAnalyticsService implements IGoogleAnalyticsService {
  pageView(payload: PageViewEventData) {
    this.trackEvent('page_view', payload)
  }

  trackEvent<T extends GAEvent>(eventName: T, data: EventMap[T]): void {
    if ('gtag' in window && typeof window.gtag === 'function') {
      return window.gtag('event', eventName, data)
    }
    console.warn('Google Analytics is not initialized')
  }
}
